"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7834],{

/***/ 96434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_TravelInfoPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/detailpackage/productpopup.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 240px;\n	margin-bottom: 20px;\n\n	.swiper-wrapper .swiper-slide {\n		width: 100%;\n		height: 240px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 20px;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1.6;\n	margin-bottom: 15px;\n	color: var(--default-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var SlideWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8fda08df-0"
})(_templateObject());
var SubTitle = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-8fda08df-1"
})(_templateObject1());
var InfoText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-8fda08df-2"
})(_templateObject2());


// EXTERNAL MODULE: ./components/style/slide/index.tsx
var slide = __webpack_require__(91587);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 4 modules
var popup = __webpack_require__(16628);
// EXTERNAL MODULE: ./framework/ui/desktop/slide/index.ts + 6 modules
var desktop_slide = __webpack_require__(93774);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts
var useConfigureAxios = __webpack_require__(83839);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventInfoImages.ts
var useEventInfoImages = __webpack_require__(64853);
// EXTERNAL MODULE: ./node_modules/@yb/ui/desktop/common/Noimage/index.cjs
var Noimage = __webpack_require__(78860);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/TravelInfoPopup.tsx

















var label = {
    10: "도시",
    20: "숙소",
    30: "관광지",
    40: "먹거리",
    50: "즐길거리",
    60: "쇼핑",
    70: "선택관광",
    80: "골프"
};
var path = {
    10: "",
    20: "/residence",
    30: "/itnr-info",
    40: "/itnr-info",
    50: "/itnr-info",
    60: "/itnr-info",
    70: "/itnr-info",
    80: "/golf"
};
var TravelInfoPopup = function(props) {
    var ref;
    var ref1 = (0,react.useState)(null), tourDetail = ref1[0], setTourDetail = ref1[1];
    var trv = props.trv, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "trv"
    ]);
    var trvCd = trv.trvCd, trvInfoId = trv.trvInfoId;
    var imageFetch = (0,useEventInfoImages/* default */.Z)(trvInfoId);
    var tourImage = ((ref = imageFetch.data) === null || ref === void 0 ? void 0 : ref.body) || [];
    var asyncTourDescriptionFetch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, res, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.url = "".concat(config_public/* default.ENV_PORTAL_API_URL */.Z.ENV_PORTAL_API_URL, "/pkg/event-info/").concat(trvInfoId).concat(path[trvCd]), _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        setTourDetail((ref = res.data) === null || ref === void 0 ? void 0 : ref.body);
                        return [
                            2
                        ];
                }
            });
        });
        return function asyncTourDescriptionFetch() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (tourDetail) return;
        path[trvCd] && asyncTourDescriptionFetch();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        size: "regular",
        title: label[trvCd],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                children: [
                    tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.korNm,
                    " ",
                    (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.locNm) && "(".concat(tourDetail.locNm, ")")
                ]
            }),
            tourImage.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_slide/* GuideSlide */.Zj, {
                    perView: 2,
                    spaceBetween: 12,
                    children: tourImage.map(function(ti) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide/* GuideSlideImg */.BN, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Noimage/* Noimage */.T, {
                                    width: "354px",
                                    height: "240px",
                                    src: ti.imageThum2,
                                    alt: ""
                                })
                            })
                        }, ti.imageThum2 + String(ti.sortOrder));
                    })
                })
            }),
            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                dangerouslySetInnerHTML: {
                    __html: tourDetail.content
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                line: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                        children: "관광지 정보"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: 120
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: 240
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: 120
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: 240
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.addrOne) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "주소"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.addrOne
                                    })
                                ]
                            }),
                            ((tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.telNo) || (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.faxNo)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "전화"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.telNo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "팩스"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.faxNo
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.homepageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "홈페이지"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: tourDetail.homepageUrl,
                                            children: tourDetail.homepageUrl
                                        })
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.operHour) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "운영시간"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.operHour
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.priceInfo) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "입장료"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.priceInfo
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.mapTrans) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "교통편"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.mapTrans
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.addFacilities) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "부대시설"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.addFacilities
                                    })
                                ]
                            }),
                            (tourDetail === null || tourDetail === void 0 ? void 0 : tourDetail.cautionTip) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "참고사항"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        colSpan: 3,
                                        children: tourDetail.cautionTip
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var desktop_TravelInfoPopup = (TravelInfoPopup);


/***/ }),

/***/ 44240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _FRAMEWORK_ui_desktop_popup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16628);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30719);
/* harmony import */ var _COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91587);
/* harmony import */ var _COMPONENTS_style_detailpackage_detailimage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8258);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22004);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17550);
/* harmony import */ var _yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78860);














var ImageVideoPopComponent = function(props) {
    var title = props.title, images = props.images, videos = props.videos, overlayProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(props, [
        "title",
        "images",
        "videos"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var PaginationParams = {
        type: "fraction",
        formatFractionCurrent: function formatFractionCurrent(number) {
            if (number < 10) {
                return "0".concat(number);
            } else {
                return number;
            }
        },
        formatFractionTotal: function formatFractionTotal(number) {
            if (number < 10) {
                return "0".concat(number);
            } else {
                return number;
            }
        }
    };
    var initialPlay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Array.from({
            length: videos.length
        }, function() {
            return false;
        });
    }, [
        videos
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialPlay), playing = ref1[0], setPlaying = ref1[1];
    var onPause = function() {
        setPlaying(initialPlay);
    };
    var onPlaying = function(index, status) {
        var copy = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(playing);
        copy[index] = status;
        setPlaying(copy);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_popup__WEBPACK_IMPORTED_MODULE_2__/* .PopupContainer */ .kZ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, overlayProps), {
        title: title,
        size: "regular",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_detailimage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ZoomSlider */ .zR, {
                    loop: true,
                    navigation: true,
                    pagination: PaginationParams,
                    thumbs: {
                        swiper: thumbsSwiper
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Thumbs */ .o3
                    ],
                    initialSlide: 0,
                    onSwiper: function() {
                        return setPlaying(Array.from({
                            length: videos.length
                        }, function() {
                            return true;
                        }));
                    },
                    onSlideChange: onPause,
                    children: [
                        videos === null || videos === void 0 ? void 0 : videos.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ZoomSlideImg */ .ql, {
                                    types: "movie",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        url: item.vimeoUrl,
                                        width: 720,
                                        height: 495,
                                        playing: playing[index],
                                        onPlay: function() {
                                            return onPlaying(index, true);
                                        },
                                        onPause: function() {
                                            return onPlaying(index, false);
                                        },
                                        volume: 0,
                                        muted: true,
                                        controls: true
                                    })
                                })
                            }, index);
                        }),
                        images.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ZoomSlideImg */ .ql, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_13__/* .Noimage */ .T, {
                                        width: "720px",
                                        height: "495px",
                                        src: item.imageThum4,
                                        alt: item.imageNote
                                    })
                                })
                            }, index + videos.length);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ThumbsSlider */ .ak, {
                    spaceBetween: 10,
                    slidesPerView: 5,
                    onSwiper: setThumbsSwiper,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Thumbs */ .o3
                    ],
                    observer: true,
                    children: [
                        videos === null || videos === void 0 ? void 0 : videos.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ThumbsSlideImg */ .SU, {
                                    types: "movie",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_13__/* .Noimage */ .T, {
                                        width: "136px",
                                        height: "90px",
                                        src: item.vimeoThum1,
                                        alt: item.vimeoNote
                                    })
                                })
                            }, index);
                        }),
                        images.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_slide__WEBPACK_IMPORTED_MODULE_5__/* .ThumbsSlideImg */ .SU, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_13__/* .Noimage */ .T, {
                                        width: "136px",
                                        height: "90px",
                                        src: item.imageThum4,
                                        alt: item.imageNote
                                    })
                                })
                            }, index + videos.length);
                        })
                    ]
                })
            ]
        })
    }));
};
var ImageVideoPop = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        logMsg: "Popup ImageVideoPop Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageVideoPopComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageVideoPop);


/***/ })

}]);